import 'css-chunksrc/client/scenes/organizationalUnitEdition/styles.scss';export default {
  "organizationalUnitEdition": "_organizationalUnitEdition_qu8lh_1",
  "main": "_main_qu8lh_5",
  "group": "_group_qu8lh_12",
  "title": "_title_qu8lh_16",
  "input": "_input_qu8lh_23",
  "buttons": "_buttons_qu8lh_35"
};